export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            如果你有完结漫画推荐、合作投稿或任何问题与建议，欢迎通过以下方式联系我们。迷妹漫画团队期待你的来信。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 rounded-2xl bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-1">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100/80 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-accent-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">投稿推荐</h3>
              <p className="text-xs text-foreground-600">contact@mimei-comic.com</p>
            </div>

            <div className="p-5 rounded-2xl bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-1">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100/80 flex items-center justify-center">
                <i className="ri-chat-smile-2-line text-xl text-primary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-600">feedback@mimei-comic.com</p>
            </div>

            <div className="p-5 rounded-2xl bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-1">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100/80 flex items-center justify-center">
                <i className="ri-briefcase-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600">biz@mimei-comic.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}